import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ImgHeaderSubheader from "../../../components/SignUpLoginForgot/ImgHeaderSubheader";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import LoginInputfield from "../../../components/SignUpLoginForgot/LoginInputfield";
import Button from "../../../components/Button";
import { Colors, Text } from "../../../config";
import {
  LoginLayout,
  WidthWrapper,
  FlexWithGap,
  LoginInnerWrapperOther,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import LabelLink from "../../../components/SignUpLoginForgot/LabelLink";
import { register } from "../../../services/userServices";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import ErrorSuccessModal from "../../../components/ErrorSuccessModal";
import { useLoaderContext } from "../../../contexts/loaderContext";
const getStartedIcon = require("../../../assets/images/LoginIcon.png");
const createAccountImg = require("../../../assets/images/create_account_img.png");

const SignUp = () => {
  const navigate = useNavigate();
  const [employeeID, setEmployeeID] = useState("");
  const [employeeIDError, setEmployeeIDError] = useState("");
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const { setLoader } = useLoaderContext();

  const handleChange = (e) => {
    setEmployeeIDError("");
    setEmployeeID(e.target.value);
  };

  const handleBackClick = () => {
    navigate("/auth/login");
  };

  const handleLogin = () => {
    navigate("/auth/login");
  };

  const handleSend = () => {
    if (employeeID === "") {
      setEmployeeIDError("Please enter Employee ID");
    } else {
      const registerData = {
        empId: employeeID,
      };
      postRegisterEmpId(registerData);
    }
  };

  const postRegisterEmpId = async (registerData) => {
    console.log(registerData);
    setLoader(true);
    try {
      const response = await register(registerData);
      console.log(response);
      if (response.status === 201) {
        setLoader(false);
        const responseData = response.data.data;
        if (responseData.redirectPage === "LoginPage") {
          setAlreadyRegistered(Text.looksLikeAlreadyHaveAccountLogin);
        } else {
          localStorage.setItem("userId", responseData.userId);
          localStorage.setItem("phone", responseData.phone);
          navigate("/auth/signup/otp");
        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const closeAlreadyRegisteredModal = () => {
    setAlreadyRegistered(false);
    navigate("/auth/login");
  };

  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <WidthWrapper maxWidth="42rem">
            <ImgHeaderSubheader
              imgSrc={createAccountImg}
              header={Text.createAccount}
              subheader={Text.signUpAndDiscover}
            />
          </WidthWrapper>
          <WidthWrapper maxWidth="22.5rem">
            <FlexWithGap gap="2rem">
              <LoginInputfield
                label={Text.employeeID}
                placeholder={Text.enterEmployeeID}
                value={employeeID}
                onChange={handleChange}
                errorText={employeeIDError}
              />
              <Button
                label={Text.getStarted}
                onClick={handleSend}
                rightImgSrc={getStartedIcon}
                fontColor={Colors.white}
                fontSize="1.375rem"
                fontWeight="700"
                bgColor={Colors.brandTwo}
                topBottomPadding="0.75rem"
                labelImgGap="0.5rem"
              />
            </FlexWithGap>
          </WidthWrapper>
          <LabelLink
            labelText={Text.alreadyHaveAnAccountQ}
            linkText={Text.login}
            handleClick={handleLogin}
          />
        </LoginInnerWrapperOther>
      </LoginLayout>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
      {alreadyRegistered && (
        <ErrorSuccessModal
          headerText={Text.userExists}
          subheaderText={alreadyRegistered}
          setClose={closeAlreadyRegisteredModal}
          buttonText="OK"
          onButtonClick={closeAlreadyRegisteredModal}
        />
      )}
    </>
  );
};

export default SignUp;
